import { NamedDataSourceRecordReferenceBase } from "abweb/dto/generated/gds/NamedDataSourceRecordReferenceBase";
import { StringUtils } from "abweb/utils/StringUtils";
export class NamedDataSourceRecordReference extends NamedDataSourceRecordReferenceBase {
  static createNamedDataSourceRecordReference(dataSourceId, name, recordId) {
    const retVal = new NamedDataSourceRecordReference();
    retVal.initNamedDataSourceRecordReference(dataSourceId, name, recordId);
    return retVal;
  }
  get isValid() {
    return !(StringUtils.isNullOrEmpty(this.dataSourceId) || StringUtils.isNullOrEmpty(this.name) || StringUtils.isNullOrEmpty(this.recordId));
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=NamedDataSourceRecordReference.js.map
